import React from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import moment from 'moment';
import { NavLink } from "react-router-dom";
import {getInventorycategorys, getInventorycategory, registerInventorycategory, updateInventorycategory, deleteInventorycategory } from './../../actions/inventorycategory';
import {getInventorytypes } from './../../actions/inventorytype';
import FormInventoryCategory from "views/Form/FormInventoryCategory";
import $ from 'jquery';
import { Col, Container, Row } from "reactstrap";


const locs = {
    1:'Kaimji',
    2:'Jebba',
    3:'HQ'
}
class BottomCard extends React.Component {
   constructor(props){
       super(props);
       this.state ={
           id:null,
           cat:null,
            grp:null,
            afid:false,
            tfid:false,
            cfid:false,
            mfid:false,
            ifid:false,
            mid:null,
            fid:false,
            data:{},
            subtopic:'All Categories',
            started:'',
            ended:'',
            daterange:'',
            isshown:{}

       }
   }

    async componentDidMount(){
        //GET PROPS
        let id = parseInt(this.props.id);
        let categoryid = this.props.categoryid ? parseInt(this.props.categoryid) : null;
        let choicestarted = this.props.choicestarted ? this.props.choicestarted : null;
        let choiceended = this.props.choiceended ? this.props.choiceended : null;
        let started = this.props.defaultstarted ? this.props.defaultstarted : null;
        let ended = this.props.defaultended ? this.props.defaultended : null;
        
        if(choicestarted !== null && choiceended !== null && choiceended > choicestarted)
        {
            started = choicestarted;
            ended = choiceended;
        }

        let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
        
        this.setState({
            id:id, 
            cat:categoryid,
            started:started,
            ended:ended,
            daterange:daterange
        });
        
       
            //GET ALL CATEGORYS
            let params = {
                data:JSON.stringify({'locationid':this.props.user.location}),
                cat:'categoryinventoryall',
                table:'inventory_categorys'
            }
         
         this.setState({subtopic:'Inventory Categories List'});
         await  this.props.getInventorycategorys(params);
        
        
        $('#myTablex').DataTable();
        //tb.destroy();
    }
        
    async componentDidUpdate(prevProps, prevState)
    {
        //GET PROPS
        if(prevProps.user.location !== this.props.user.location || prevProps.id !== this.props.id || prevProps.choicestarted !== this.props.choicestarted || prevProps.choiceended !== this.props.choiceended)
        {
        let id = parseInt(this.props.id);
        let categoryid = this.props.categoryid ? parseInt(this.props.categoryid) : null;
        let choicestarted = this.props.choicestarted ? this.props.choicestarted : null;
        let choiceended = this.props.choiceended ? this.props.choiceended : null;
        let started = this.props.defaultstarted ? this.props.defaultstarted : null;
        let ended = this.props.defaultended ? this.props.defaultended : null;
        this.setState({id:id, cat:categoryid});
        this.setState({grp:id});
        
        if(choicestarted !== null && choiceended !== null && choiceended > choicestarted)
        {
            started = choicestarted;
            ended = choiceended;
        }

        let daterange = ' '+moment(started).format('MMMM Do YYYY') + ' - ' + moment(ended).format('MMMM Do YYYY');
        
        this.setState({
            id:id, 
            cat:categoryid,
            started:started,
            ended:ended,
            daterange:daterange
        });
       
       
            //GET ALL CATEGORYS
            let params = {
                data:JSON.stringify({'locationid':this.props.user.location}),
                cat:'categoryinventoryall',
                table:'inventory_categorys'
            }
         
         this.setState({subtopic:'Inventory Categories List'});
         await this.props.getInventorycategorys(params);
        $('#myTablex').DataTable();
        
    }
    }
    componentWillUnmount(){
        $('#myTablex').DataTable().destroy();
    }
    //EDIT CATEGORY
    categoryEditForm = (id, dat) =>{
        this.props.getInventorycategory(id);
        this.setState({cfid:true, mid:id, data:dat});
    }
    //REPORT
    categoryReport = (cid, catname) =>{
        this.setState({id:5});
        //GET ALL INVENTORYS
         //GET INVENTORY TRANSACTIONS PARTICULAR TYPE
            //DATE RANGE NEEDED
            //INVTORY ID NEEDED
            let dt = {
                'starts':this.state.started,
                'ends':this.state.ended,
                'inventoryid':cid,
            }
            let params = {
                data:JSON.stringify(dt),
                cat:'inventorytransaction',
                table:'inventory_transactions'
            }
        let catn = 'Inventory History :' + catname + this.state.daterange;
        this.setState({subtopic:catn});
        this.props.getInventorytransactions(params);
    }
    //EXPAND
    categoryExpand = (cid, catname) =>{
        this.setState({id:3});
        //GET ALL INVENTORYS
        let params = {
            data:{'categoryid':cid},
            cat:'categoryinventory',
            table:'inventory_types'
        }
        this.setState({subtopic: catname});
        this.props.getInventorytypes(params);
    }
    //EXPAND
    categoryAdd = (id, dat) =>{
        this.props.inventoryAdd(id)
    }
    //DELETE CATEGORY
    categoryDeleteForm = (id, dat) =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('is_delete', 1);
                fd.append('cat', 'update');
                fd.append('table', 'inventory_categorys');
                this.props.updateInventorycategory(fd);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })      
    }
    //ACTIVATE CATEGORY
    categoryActivateForm = (id, ac) =>{
        let act = ac === 1 ? 0 : 1;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('is_active', act);
        fd.append('cat', 'update');
        fd.append('table', 'inventory_categorys');
        this.props.updateInventorycategory(fd);
    }
     //ADD A TRANSACTION
    addTransactionForm = id =>{
        this.props.inventoryTransactionAdd(id)
    }
    //EDIT INVENTORY
    editForm = id =>{
        this.props.getInventorytype(id);
        this.setState({fid:true, mid:id});
    }
  
    //DELETE INVENTORY
    deleteForm = id =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                let fd = new FormData();
                fd.append('id', id);
                fd.append('is_delete', 1);
                fd.append('cat', 'update');
                fd.append('table', 'inventory_types');
                this.props.updateInventorytype(fd);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
        
    }
    //ACTIVATE INVENTORY
    activateForm = (id, ac) =>{
        let act = ac === 0 ? 1 : 0;
        let fd = new FormData();
        fd.append('id', id);
        fd.append('is_active', act);
        fd.append('cat', 'update');
        fd.append('table', 'inventory_types');
        this.props.updateInventorytype(fd);
    }
    //EDIT INVENTORY TRANSACTION
    transactionEditForm = id =>{
        this.props.getInventorytransaction(id);
        this.setState({tfid:true, mid:id});
    }
    //DELETE INVENTORY TRANSACTION
    transactionDeleteForm = id =>{
        Swal.fire({
            title: 'Are you sure?',
            text: "You will not be able restore",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
        
            if (result.value) {
                this.props.deleteInventorytransaction(id);
              Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
              )
            }
          })
        
    } 
    loadShown = (id, cat) =>{
          let ar = {};
          if(cat === 0)
          {
              ar[id] = true;
          }else{
              ar[id] = false;
          }
          this.setState({isshown:ar});
    }
    render() {
        let { cfid, mid, isshown, data } = this.state  || '';
        let datas = this.props.inventorycategorys.inventorycategorys;
        let tabl = datas && Array.isArray(datas) ? datas.map((prop, ind)=>{
            return <tr 
            key={ind}
                        style={{padding:'1px', margin:'0px'}}
                       
                        >
                        <td className='text-center' width='20px' data-col-width='9' style={{maxWidth:'18px'}}>{ind + 1}</td>
                        <td className='text-left'>
                             {parseInt(prop.is_active) === 0 ? prop.name : <strike>{prop.name}</strike> }
                             
                        </td>
                        <td className='text-center' style={{maxWidth:'10px'}} >{prop.qty}</td>
                        <td>
                          
                        <span className='reportcontrol pull-right'>
                                    <NavLink to={`/account/inventorys/${prop.id}`}><i className='fa fa-list'></i></NavLink>
                                    <NavLink to={`/account/inventoryhistory/${prop.id}/1`}><i className='fa fa-list-alt'></i></NavLink>
                                    <NavLink to={`/account/inventoryreport/${prop.id}/1`}><i className='fa fa-file'></i></NavLink>
                                    <a onClick={()=>this.categoryActivateForm(parseInt(prop.id), parseInt(prop.is_active))} href='#'>{<i className= {parseInt(prop.is_active) === 0 ? "fa fa-thumbs-up" : "fa fa-thumbs-down"}></i>}</a>
                                    <a onClick={()=>this.categoryAdd(prop.id, prop)} href='#'><i className='now-ui-icons ui-1_simple-add'></i></a>
                                    <a onClick={()=>this.categoryEditForm(prop.id, prop)} href='#'><i className='fa fa-edit'></i></a>
                                    <a onClick={()=>this.categoryDeleteForm(prop.id, prop)} href='#'><i className='now-ui-icons ui-1_simple-remove'></i></a>
                                </span>
                           
                        </td>
                        
                        
                    </tr>
                }): '';
        


        return (
            <>
            
            {cfid === true? 
            <FormInventoryCategory
                st={cfid}
                mid={mid}
                data={data}
                handleClose={()=>this.setState({mid:null, cfid:false, data:{}})}
            />:''}
            
              <div className="content">
                  <div className='card'>
                  <div className='card-header tablecardheader'>
                      <Container xs='12'>
                          <Row xs='12'>
                              <Col sm='8' xs='12'>
                              <h4 className='cardtitl'> Inventory Categories</h4>
                              </Col >
                              <Col sm='4' xs='12' className='pull-right'>
                              <a href='#' className='btn btn-outline-info btn-sm' onClick={()=>this.categoryEditForm(null, {})}><i className='now-ui-icons ui-1_simple-add'></i> Add Inventory Category</a>
                              </Col >

                          </Row>
                      </Container>
                  
                  </div>
                  <div className='card-body table-responsive'>
                    <table className='table table-bordered display nowrap mytables table-striped  table-condensed table-hover' id='myTablexsz' width='100%'>
                        <thead>
                            <tr>
                                <th style={{width:'30px'}}>SN.</th>
                                <th>Category</th>
                                <th style={{width:'50px'}} className='text-center'>QTY.</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tabl}
                        </tbody>
                    </table>
                  </div>
                  </div>
              </div>
            </>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({ 
    user:state.userReducer,
    inventorycategorys:state.inventorycategoryReducer
  })
  
export default connect(mapStateToProps, 
    { 
        getInventorycategorys, 
        getInventorycategory, 
        registerInventorycategory,
        updateInventorycategory,
        deleteInventorycategory,
        getInventorytypes
    })(BottomCard)
